module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-002.8fd2d50b.jpg";